import { _id } from 'src/_mock/assets';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

// const MOCK_TITLE = _postTitles[2];

const ROOTS = {
  AUTH: '/auth',
  MANAGE: '/manage',
  CLIENT: '/client',
  DASHBOARD: '/dashboard',
  ADMINISTRATOR: '/administrator',
  TEACHER: '/teacher',
};

// ----------------------------------------------------------------------

const pathsManage = (path: string) => ({
  chat: `${path}/chat`,
  fileManager: `${path}/file-manager`,
  learningprogress: `${path}/learning-progress`,
  general: {
    app: `${path}/app`,
    courseAnalytics: `${path}/analytics-course`,
    fileAnalytics: `${path}/bunny-analytics`,
  },
  profile: {
    root: `${path}/profile`,
  },
  user: {
    root: `${path}/user`,
    new: `${path}/user/new`,
    list: `${path}/user/list`,
    cards: `${path}/user/cards`,
    profile: `${path}/user/profile`,
    account: `${path}/user/account`,
    excel: `${path}/user/excel`,
    edit: (id: string) => `${path}/user/${id}/edit`,
    demo: {
      edit: `${path}/user/${MOCK_ID}/edit`,
    },
    location: `${path}/user/location`,
    group: `${path}/user/group`,
    department: `${path}/user/department`,
    position: `${path}/user/position`,
    //
    online: `${path}/user/online`,
  },
  question: {
    question: {
      list: `${path}/question`,
      create: `${path}/question/create`,
      excel: `${path}/question/create/excel`,
    },
    groups: {
      list: `${path}/question/group`,
      create: `${path}/question/group/create`,
    },
    exam: {
      list: `${path}/question/exam`,
      create: `${path}/question/exam/create`,
    },
    survey: {
      list: `${path}/question/survey`,
      create: `${path}/question/survey/create`,
      preCourse: `${path}/question/survey/pre-course`,
    },
  },
  email: {
    root: `${path}/email`,
    template: `${path}/email/template`,
  },
  notify: {
    root: `${path}/notify`,
    new: `${path}/notify/new`,
  },
  certificate: {
    root: `${path}/certificate`,
    new: `${path}/certificate/new`,
    bulk: `${path}/certificate/bulk`,
  },
  calendarManage: {
    root: `${path}/calendar`,
    schedule: {
      root: `${path}/calendar/schedule`,
      new: `${path}/calendar/schedule/new`,
    },
    meetingSchedule: {
      root: `${path}/calendar/meeting-schedule`,
      new: `${path}/calendar/meeting-schedule/new`,
    },
    testSchedule: {
      root: `${path}/calendar/test-schedule`,
      new: `${path}/calendar/test-schedule/new`,
    },
  },
  exportReport: {
    root: `${path}/export-report`,
    detailReport: `${path}/export-report/detail-report`,
    weeklyReport: `${path}/export-report/weekly-report`,
    academicTranscript: `${path}/export-report/academic-transcript`,
    chartReport: `${path}/export-report/chart`,
  },
  extends: {
    systemAccess: `${path}/extend/system-access`,
    systemLogs: `${path}/extend/system-logs`,
    troubleshooting: `${path}/extend/troubleshooting`,
  },
  lectureManage: {
    root: `${path}/lecture`,
    new: `${path}/lecture/new`,
  },
  courseManage: {
    root: `${path}/course`,
    list: `${path}/course/list`,
    new: `${path}/course/new`,
    table: `${path}/course/table`,
    exportJson: `${path}/course/export-json`,
    assignmentList: `${path}/course/assignment-list`,
    category: `${path}/course/categories`,
    contribution: `${path}/course/contribution`,
    addChildCourse: `${path}/course/add-child-course`,
    addUserToCoude: `${path}/course/add-user-to-course`,
  },
  orderManage: {
    root: `${path}/order`,
    details: (id: string) => `${path}/order/${id}`,
    demo: {
      details: `${path}/order/${MOCK_ID}`,
    },
  },
  new: {
    root: `${path}/news`,
    action: {
      create: `${path}/news/create`,
    },
  },
  settings: {
    root: `${path}/setting`,
    passRule: `${path}/setting/pass-rule`,
    emailSetting: `${path}/setting/email-setting`,
    emailHost: `${path}/setting/email-host`,
    regulation: `${path}/setting/regulation`,
    website: `${path}/setting/website`,
    subdomain: `${path}/setting/sub-domain`,
  },
});

export const paths = {
  auth: {
    root: `${ROOTS.AUTH}/sign-in`,
    jwt: {
      signIn: `${ROOTS.AUTH}/sign-in`,
      verify: `${ROOTS.AUTH}/verify`,
      updatePassword: `${ROOTS.AUTH}/update-password`,
      resetPassword: `${ROOTS.AUTH}/forgot-password`,
    },
  },
  administrator: {
    root: ROOTS.ADMINISTRATOR,

    ...pathsManage(ROOTS.ADMINISTRATOR),
  },
  manage: {
    root: ROOTS.MANAGE,
    ...pathsManage(ROOTS.MANAGE),
  },
  client: {
    root: ROOTS.CLIENT,
    chat: `${ROOTS.CLIENT}/chat`,
    notify: `${ROOTS.CLIENT}/notify`,
    learningprogress: `${ROOTS.CLIENT}/learning-progress`,
    mentoring: `${ROOTS.CLIENT}/mentoring`,
    certificate: `${ROOTS.CLIENT}/certificate`,
    wishlist: `${ROOTS.CLIENT}/wishlist`,
    contribution: {
      root: `${ROOTS.CLIENT}/contribution`,
      create: `${ROOTS.CLIENT}/contribution/create`,
    },
    calendar: {
      root: `${ROOTS.CLIENT}/calendar`,
      schedule: {
        root: `${ROOTS.CLIENT}/calendar/schedule`,
      },
      meetingSchedule: {
        root: `${ROOTS.CLIENT}/calendar/meeting-schedule`,
      },
      testSchedule: {
        root: `${ROOTS.CLIENT}/calendar/test-schedule`,
      },
    },
  },
  teacher: {
    root: `${ROOTS.MANAGE}/course/table`,
    contribution: {
      root: `${ROOTS.TEACHER}/contribution`,
      create: `${ROOTS.TEACHER}/contribution/create`,
    },
    mentoring: `${ROOTS.TEACHER}/mentoring`,
    ...pathsManage(ROOTS.TEACHER),
  },
};
